import { Component, OnInit } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { TrackingDataService } from 'app/d2z/service/tracking-data.service';
import { NgxSpinnerService } from 'ngx-spinner';
declare var $: any;

@Component({
  selector: 'd2z-agent-allocation',
  templateUrl: './agent-allocation.component.html',
  styleUrls: ['./agent-allocation.component.css']
})
export class AgentAllocationComponent implements OnInit {
  shipmentScanForm: FormGroup;

agent: String;
  errorMsg: string;
    successMsg: String
  constructor(    
  private activatedRoute: ActivatedRoute,  
  private spinner: NgxSpinnerService,
   public trackingDataService : TrackingDataService,

) { this.shipmentScanForm = new FormGroup({
      referenceNumber: new FormControl(),
      shipmentNumber: new FormControl("")
    }); }

  ngOnInit() {

 this.activatedRoute.params.subscribe(params => {
    this.agent = params['agent']; 
   
  });
  }
scanShipment(){
  
    this.errorMsg = null;
    this.successMsg = null;
    if((this.shipmentScanForm.value.shipmentNumber == null || this.shipmentScanForm.value.shipmentNumber == '')){
      this.errorMsg = "**Please Enter the Shipment Number";
    }
    if(this.shipmentScanForm.value.referenceNumber == null || this.shipmentScanForm.value.referenceNumber == ''){
      this.errorMsg = "**Please Enter the Reference Number";
    }
   
    if(this.errorMsg == null ){
      var referenceNumberData = this.shipmentScanForm.value.referenceNumber.split("\n");
      var refrenceNumList = referenceNumberData.join(',');
        this.spinner.show();
        this.trackingDataService.scanToShipment(refrenceNumList, this.shipmentScanForm.value.shipmentNumber, 
          'referenceNumber',this.agent , (resp) => {
          this.spinner.hide();
  		   this.successMsg = "Shipment allocated successfully";
  		             this.shipmentScanForm.reset();

          $('#scanShipmentModal').modal('show');
          setTimeout(() => {
            this.spinner.hide();
          
          }, 5000);
        });
 
     
    }
  
  }
  
}



// WEBPACK FOOTER //
// ./src/app/d2z/views/superuser-level/vic-agent/agent-allocation/agent-allocation.component.ts